// Keep frontend-specific enums that may not be in generated types
export enum EventQuestionCategory {
  EVENT = "EVENT",
  DINNER = "DINNER",
  SIGNUP = "SIGNUP",
}

export enum EventQuestionSlug {
  WHEN = "when",
  WHERE = "where",
  MESSAGE_FOR_GUESTS = "messageForGuests",
  PREFERRED_LANGUAGE = "preferredLanguage",
  PREFERRED_COST = "preferredCost",
  DIETARY_RESTRICTIONS = "dietaryRestrictions",
}

export enum EventQuestionType {
  SELECT_SINGLE = "select_single",
  SELECT_MULTIPLE = "select_multiple",
  TEXT = "text",
}

export enum LanguagePreference {
  ENGLISH = "ENGLISH",
  KOREAN = "KOREAN",
  BOTH = "BOTH",
}

export enum CostPreference {
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
}

export enum DietaryRestriction {
  NONE = "NONE",
  VEGAN = "VEGAN",
  VEGETARIAN = "VEGETARIAN",
  GLUTEN_FREE = "GLUTEN_FREE",
  OTHER = "OTHER",
}

export enum AttendanceStatus {
  ON_TIME = "ON_TIME",
  LATE = "LATE",
  NO_SHOW = "NO_SHOW",
  CANCELLED = "CANCELLED",
}

export enum GroupGenderPreference {
  ALL_GENDERS_OKAY = "ALL_GENDERS_OKAY",
  SAME_GENDER_PREFERRED = "SAME_GENDER_PREFERRED",
}

export enum GroupAgePreference {
  ALL_AGES_OKAY = "ALL_AGES_OKAY",
  SAME_AGE_PREFERRED = "SAME_AGE_PREFERRED",
}
